import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState, useEffect, useRef } from "react";
import { API_BASE } from "../api/config";
import { QRCodeCanvas } from "qrcode.react";




function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [copied, setCopied] = useState(false);
  const qrRef = useRef(null);

const handleCopyLink = async () => {
  try {
    await navigator.clipboard.writeText(SELF_ORDER_URL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  } catch (err) {
    console.error("Copy failed", err);
  }
};

  

  const API_URL = `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=check_login`;
  
  const SELF_ORDER_URL = `${window.location.origin}/self-order-by-otp`;



  useEffect(() => {
    const fetchCompany = async () => {
      try {
		  const apiUrl = `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=company&transac=get`;

      // 🔥 CONSOLE THE ACTUAL API URL
      console.log("COMPANY API URL:", apiUrl);
        const response = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=company&transac=get`
        );
        const result = await response.json();
        if (result.status === "ok" && result.data.length > 0) {
          setCompanyName(result.data[0].company_name);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };
    fetchCompany();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          login_name: username,
          login_password: password,
        }),
      });

      const result = await response.json();

      if (result.status === "ok") {
           const parsed = JSON.parse(result.data);

          const userType = Number(parsed[0].login_type); // 🔥 FIX
          const userBranch = parsed[0].branch || "";

          login(username, userType, userBranch);

          if ([3, 4, 5].includes(userType)) {
            navigate("/kots-by-kitchen");
          } else {
            navigate("/dashboard");
          }
      } else {
        setError("Invalid username or password ❌");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  
  const handleDownloadQR = () => {
  if (!qrRef.current) return;

  // Get canvas as data URL
  const canvas = qrRef.current.querySelector("canvas") || qrRef.current;
  const url = canvas.toDataURL("image/png");

  // Create temporary link to download
  const link = document.createElement("a");
  link.href = url;
  link.download = "self_order_qr.png";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-r from-blue-900 via-blue-800 to-orange-500">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-96">
        <h1 className="text-3xl font-bold text-center text-blue-800 mb-6">
          {companyName || "Loading..."}
        </h1>

        <form className="space-y-5" onSubmit={handleLogin}>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              autoFocus
              required
              className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          {error && <p className="text-red-600 text-sm">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className={`w-full text-white py-2 rounded-lg font-semibold transition ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-blue-700 to-orange-500 hover:opacity-90"
            }`}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
	
<div className="mt-6 text-center border-t pt-4">
  <p className="text-sm text-gray-600 mb-2 font-semibold">
    Self Order (Scan QR)
  </p>

  <div className="flex justify-center mb-2">
    <QRCodeCanvas
	 ref={qrRef}
      value={SELF_ORDER_URL}
      size={140}
      bgColor="#ffffff"
      fgColor="#000000"
      level="H"
      includeMargin
    />


  </div>
  	<button
  onClick={handleDownloadQR}
  className="mt-2 px-4 py-1 bg-green-600 text-white rounded hover:bg-green-700 text-sm"
>
  Download QR
</button>

  {/* 🔗 Copyable Link */}
  <div className="text-xs break-all text-blue-700 cursor-pointer hover:underline">
    <span onClick={handleCopyLink}>
      {SELF_ORDER_URL}
    </span>
  </div>

  {/* ✅ Copy Feedback */}
  {copied && (
    <p className="text-xs text-green-600 mt-1">
      ✔ Link copied to clipboard
    </p>
  )}

  <p className="text-xs text-gray-500 mt-2">
    Scan or copy link to place order without login
  </p>
</div>

</div>

    </div>
  );
}

export default Login;
